const WASTE_TYPE_ID_OVERRIDES: Record<string, string> = {
  "20030801": "20-03-08b",
};

export const formatWasteTypeId = (wasteTypeId: string | number): string => {
  const stringWasteTypeId = String(wasteTypeId);

  return (
    WASTE_TYPE_ID_OVERRIDES[stringWasteTypeId] ?? stringWasteTypeId.match(/.{1,2}/g)?.join("-") ?? stringWasteTypeId
  );
};
